import VoiceAssessmentHistoryScreen from '@/src/features/statistics/screens/VoiceAssessmentHistoryScreen'

export default VoiceAssessmentHistoryScreen
